import React from "react";
import { Container } from "react-bootstrap";
import Header from "../component/Layout/Header";
import team1 from "../assets/images/private-sale/ps-team-9.jpg";
import team2 from "../assets/images/private-sale/ps-team-1.jpg";
import team3 from "../assets/images/private-sale/ps-team-2.jpg";
import team4 from "../assets/images/private-sale/ps-team-5.jpg";
import team5 from "../assets/images/private-sale/ps-team-4.jpg";
import team6 from "../assets/images/private-sale/ps-team-3.jpg";
import team8 from "../assets/images/private-sale/ps-team-7.jpg";
import team9 from "../assets/images/private-sale/ps-team-8.jpg";
import teamHavanaModel from "../assets/images/private-sale/ps-team-6.jpg";
import teamRome from "../assets/images/private-sale/ps-team-rome.jpg";

const TEAM_PHOTOS = [
  { img: team1, credit: "Ralph Clermont and Leonardo V with models Lebo and Jessica in Cape Town, South Africa", dot: "#8E5CA1" },
  { img: team2, credit: "Ralph Clermont interviewing local artist Chico Muya in Cape Town, South Africa", dot: "#F4ED73" },
  { img: team3, credit: "Ralph Clermont interviewing South African designers Malcom Kluk and Christiaan Gabriel Du Toit in Cape Town", dot: "#6E919B" },
  { img: team4, credit: "Leonardo V with models in Sestri Levante", dot: "#A4CF44" },
  { img: team5, credit: "Michelle Obama gives Marc Baptiste some sartorial advice at the White House", dot: "#407BC4" },
  { img: team6, credit: "Leonardo V with model on the Italian Riviera", dot: "#C44231" },
  { img: team8, credit: "E. J. Saunders addressing the Turks and Caicos in a Public Service Announcement", dot: "#000000" },
  { img: team9, credit: "Phillipe Gelin in Havana, Cuba", dot: "#A84F50" },
  { img: teamHavanaModel, credit: "Ralph Clermont with model in Havana, Cuba", dot: "#C68534" },
  { img: teamRome, credit: "Ralph Clermont and Leonardo V in Rome", dot: "#3FA796" },
];

const TOC_ITEMS = [
  { id: "abstract", num: "01", label: "Abstract" },
  { id: "industry", num: "02", label: "Media & Entertainment Industry" },
  { id: "chic-collaborator", num: "03", label: "GEOCHIC's Chic Collaborator Concept Is What Creators Have Been Waiting For" },
  { id: "funding-model", num: "04", label: "GEOCHIC Funding Model" },
  { id: "web3", num: "05", label: "Why Web3?" },
  { id: "co-ownership-passes", num: "06", label: "Fractional Ownership" },
  { id: "utility-token", num: "07", label: "GEOCHIC Utility Token" },
  { id: "tokenomics", num: "08", label: "Tokenomics" },
  { id: "dao", num: "09", label: "Decentralized Autonomous Organization (DAO)" },
  { id: "governance", num: "10", label: "Governance" },
  { id: "roadmap", num: "11", label: "Roadmap" },
  { id: "team", num: "12", label: "Team" },
  { id: "contact", num: "13", label: "Contact" },
];

const FUNDING_STEPS = [
  {
    label: "Frictionless Submission",
    text: "The creator presents their project proposal, budget, and pitch to the GEOCHIC admin panel at zero upfront financial cost.",
  },
  {
    label: "Community Curation",
    text: (
      <>
        Approved projects are listed on the GEOCHIC dashboard as a &ldquo;Conditional
        Launch&rdquo; for community review. Community members act as Chic Curators,
        reviewing the proposals and voting to gauge market demand.
      </>
    ),
  },
  {
    label: "Lead Capital Commitment",
    text: "Once a project successfully crosses its community voting threshold, GEOCHIC intends to activate its role as the Chic Collaborator (Lead Investor), automatically contributing 5% to 50% of the target from its capital allocation pool.",
  },
  {
    label: "Compliance Activation",
    text: "GEOCHIC's automated backend infrastructure is designed to handle the regulatory requirements. The platform seeks to initiate the SEC-registered crowdfunding framework (Reg CF) and fractionalize the project's real-world legal entity (SPV) with zero out-of-pocket costs to the creator.",
  },
  {
    label: "Public Funding Round",
    text: "Community members purchase the remaining asset-backed tokens to fully fund the campaign. The final funding target listed on the dashboard is scaled to include the creator's capital, regulatory escrow fees, and the GEOCHIC platform success fee.",
  },
  {
    label: "Capital Disbursal",
    text: "The campaign closes, and the creator receives their requested capital pool to execute and produce the project.",
  },
  {
    label: "Utility & Perks",
    text: "Fractional token holders enjoy exclusive, optional utility benefits, such as having a voice in the project's creative direction, participating in productions in exotic locales, and securing exclusive VIP access at launch parties.",
  },
  {
    label: "Automated Revenue Distribution",
    text: "If the project succeeds commercially, all box-office returns, streaming revenues, or magazine sales are routed to the project's legal entity. GEOCHIC's permissioned smart contracts are structured to route these distributions directly to the community token holders as stablecoins.",
  },
  {
    label: "Secondary Liquidity",
    text: "These asset-backed tokens hold long-term digital value. Verified token holders can seek to trade their fractional project shares on regulated Alternative Trading Systems (ATS) for secondary market liquidity.",
  },
];

const WEB3_REASONS = [
  {
    label: "Instant Global Fractionalization",
    text: "Blockchain technology is designed to allow a single film, television show, or magazine to be split into thousands of secure, compliant micro-shares, drastically lowering the financial barrier to entry for fans worldwide.",
  },
  {
    label: "Automated, Trustless Distributions",
    text: "Smart contracts aim to eliminate corporate middlemen and distribution accounting delays by automatically routing box-office revenues and magazine sales directly to token holder wallets as stablecoins.",
  },
  {
    label: "Compliant, Borderless Liquidity",
    text: "By issuing permissioned security tokens, GEOCHIC aims to turn a historically illiquid asset class into a dynamic digital asset. Fans can seek secondary market liquidity with other verified users in alignment with global financial regulatory compliance.",
  },
];

const UTILITY_BENEFITS = [
  {
    label: "Staking Rewards",
    text: "Token holders can stake their native assets within the platform to participate in ecosystem rewards distributed via the network framework.",
  },
  {
    label: "Curation Governance",
    text: "Native tokens grant holders the power to vote on which community-submitted proposals GEOCHIC should back. If the community votes to approve a project, GEOCHIC automatically activates its role as the Chic Collaborator.",
  },
  {
    label: "Priority Allocation",
    text: "Users who hold and stake a designated threshold of GEOCHIC native tokens unlock early-access windows to purchase Fractional Ownership tokens for upcoming film and magazine campaigns before they open to the general public.",
  },
  {
    label: "Exclusive Access",
    text: "Native tokens allow users to unlock premium platform experiences, including behind-the-scenes content, sneak previews, creator interviews, and interactive voting rights on plots, locations, or characters in upcoming episodic series.",
  },
];

const VOTE_EXAMPLES = [
  "Casting 1 vote for a project costs 1 token (1 x 1 = 1)",
  "Casting 2 votes for a project costs 4 tokens (2 x 2 = 4)",
  "Casting 3 votes for a project costs 9 tokens (3 x 3 = 9)",
];

const TOKENOMICS = [
  { label: "Private Sale", pct: 10, color: "#dfb947", amount: "1,000,000", value: "$1.00", lock: "6 month cliff, 25% unlock monthly" },
  { label: "Presale", pct: 10, color: "#c8930a", amount: "1,000,000", value: "$2.00", lock: "25% unlock monthly after listing on Dex" },
  { label: "Public Sale", pct: 30, color: "#f20d0e", amount: "3,000,000", value: "$4.00", lock: "—" },
  { label: "Treasury + Reserve", pct: 30, color: "#2d2d2d", amount: "3,000,000", value: "—", lock: "3 month cliff, 10% unlock monthly after listing on DEX" },
  { label: "Marketing", pct: 15, color: "#767676", amount: "1,500,000", value: "—", lock: "—" },
  { label: "Team + Advisory", pct: 5, color: "#b5b5c3", amount: "500,000", value: "—", lock: "—" },
];

const VOTING_COSTS = [1, 4, 9, 16, 25, 36, 49, 64, 81, 100];

const ROADMAP = [
  {
    phase: "Phase 1",
    items: [
      "Completion of GEOCHIC website, litepaper and tokenomics",
      "Raise capital through private and presale of GEOCHIC tokens",
      "DEX listing",
    ],
  },
  {
    phase: "Phase 2",
    items: [
      "Completion of the Fractional Ownership marketplace/app",
      "Marketing blitz",
      "Publish GEOCHIC Collector's Editions print magazine for backers of GEOCHIC",
      "Fund Fractional Ownership projects approved by the GEOCHIC community for creators around the world",
      "Launch GEOCHIC Travel Movies Series via Fractional Ownership",
      "Launch GEOCHIC global music series – MUSIC IS MY LIFE via Fractional Ownership",
      "Launch GEOCHIC reality series via Fractional Ownership",
      "Audit",
    ],
  },
];

const TEAM = [
  {
    name: "Ralph Clermont",
    role: "GEOCHIC Founder, CEO & Executive Producer",
    bio: (
      <>
        Clermont has produced critically acclaimed magazines, documentaries and creative
        campaigns all over the world. He has been featured in Forbes, Folio, USA Today,
        Mediaweek, The Detroit Free Press, Allure, The Daily News, Miami Herald, New York
        Post, and more. Clermont produced and narrated{" "}
        <a href="https://m.youtube.com/watch?v=NS16qolACpo&pp=0gcJCY4Bo7VqN5tD&ra=m" target="_blank" rel="noreferrer">
          GEOCHIC&rsquo;s stylish international travel series
        </a>
        , which beautifully reimagines the travel
        documentary. His award-winning publications include Rebelle, a fashion magazine
        named one of the Most Notable Launches and WINK, winner of multiple Ozzie Awards
        for magazine excellence, including Best Cover, Best Design and Best Use of
        Typography, as well as an Annual Merit Award from the Society of Publication
        Designers for its use of photography. Additionally, he has produced high-impact
        creative campaigns for corporate and luxury clients, including Bombay Sapphire,
        the Greater Miami Convention &amp; Visitors Bureau, Hotel VIS-&Agrave;-VIS on the
        Italian Riviera, and more.
      </>
    ),
  },
  {
    name: "E. Jay Saunders",
    role: "Minister of Innovation, Technology and Energy, Turks and Caicos",
    bio: (
      <>
        Former Deputy Premier and Minister of Finance for the Turks and Caicos Islands
        Government, the Honorable E. Jay Saunders is an experienced CEO, philanthropist,
        and investor with a demonstrated history of succeeding in the telecommunications
        and FinTech industries. He is the Chairman and CEO of Domus Semo Sancus, a
        company he founded to build financial tools to empower the less fortunate.
        Saunders is the Executive Producer of{" "}
        <a href="https://m.youtube.com/watch?v=NS16qolACpo&pp=0gcJCY4Bo7VqN5tD&ra=m" target="_blank" rel="noreferrer">
          GEOCHIC&rsquo;s stylish international travel series
        </a>
        {" "}and the former CEO of Digicel, TCI.
      </>
    ),
  },
  {
    name: "Doublespace — Jane Kosstrin",
    role: "Brand Designer",
    bio: (
      <>
        Doublespace is an integrated creative agency with a longstanding reputation for
        propelling businesses forward. As founder, CEO, and Chief Creative Officer of
        Doublespace, Jane Kosstrin has been a leading contributor to the identity and
        success of some of the world&rsquo;s leading brands and cultural icons. Among
        these are ESPN2, NYC Marathon, Ben &amp; Jerry&rsquo;s, Unilever, Marvel Comics,
        GUESS Watches, Vibe, Elle, Harper&rsquo;s Bazaar, IMG Models, Disney,
        Fisher-Price, Mattel, Steelcase, WEBMD, Citibank, MasterCard, U.S. Trust, Morgan
        Stanley, MTV, Time Warner, Crunch Fitness, Robin Hood Foundation, Brooklyn
        Academy of Music, and many others. Her work has garnered numerous design awards,
        been featured in many publications, and is displayed in the Victoria and Albert
        Museum and the National Design Museum. Doublespace designed Rebelle, WINK, and
        GEOCHIC magazines.
      </>
    ),
  },
  {
    name: "Leonardo V",
    role: "GEOCHIC Film Director & Photographer",
    bio: (
      <>
        Leonardo V&rsquo;s work has been displayed in fine art museums and magazines all
        over the world, including Vogue Paris, Vogue Italia, Harper&rsquo;s Bazaar
        Italia, Elle Italia, Jane, GQ Italia, Glamour Germany, In Style Germany, Flux,
        Marie Claire Italia, GQ Spain, and GEOCHIC. Leonardo has created advertising
        campaigns for Trussardi, Fay by Tod&rsquo;s, Superga, Damiani, Lion Track by La
        Perla, Penny Black and Penny Pull by Max Mara, Gianmaria Buccellati, etc.
      </>
    ),
  },
  {
    name: "Marc Arthur Baptiste",
    role: "Filmmaker & Photographer",
    bio: (
      <>
        Marc Baptiste has photographed President Barack Obama, Shakira, Yoko Ono, Spike
        Lee, Kim Kardashian, Julia Styles, Missy Elliott, Kevin Garnett, and Chloe
        Sevigny. His work with celebrities has resulted in a variety of philanthropic
        collaborations, including photographing the DKNY/Rock the Vote campaign with Eva
        Mendes and Kate Bosworth, a UNICEF campaign with singer Ayo, and a campaign for
        the Keep a Child Alive organization with Alicia Keys, David Byrne, Lorraine
        Bracco, Cynthia Nixon, and Lenny Kravitz. Following the 2010 earthquake in Haiti,
        Baptiste partnered with Donna Karan on The Truth Exhibition to raise support for
        the region. His advertising clients include Netflix, HBO, Reebok, Nike, and
        Chevy. He has also appeared as a featured photographer and guest judge on Heidi
        Klum&rsquo;s Germany&rsquo;s Next Topmodel. His photographs have appeared in
        Cosmopolitan, Vanity Fair, Clam, Essence, Esquire, Rebelle, WINK, and GEOCHIC.
        His portfolio includes the debut album imagery for Aaliyah, Erykah Badu, and The
        Fugees.
      </>
    ),
  },
  {
    name: "Phillipe Gelin",
    role: "Photographer & Publisher",
    bio: (
      <>
        Phillipe Gelin launched REBELLE HAITI, the first fashion and lifestyle magazine
        dedicated to celebrating Haitian beauty, culture and heritage. He collaborated
        with Elite Model Management to bring the prestigious Elite Model Look, an
        internationally renowned modeling contest staged throughout the Caribbean, to
        Haiti for the first time. Gelin has created advertising campaigns for prominent
        Haitian lifestyle, hotel, and beverage brands.
      </>
    ),
  },
];

const donutGradient = () => {
  let acc = 0;
  const stops = TOKENOMICS.map((t) => {
    const start = acc;
    acc += t.pct;
    return `${t.color} ${start}% ${acc}%`;
  });
  return `conic-gradient(${stops.join(", ")})`;
};

const LitepaperPage = () => {
  return (
    <>
      <Header />
      <main className="litepaper_page">
        <section className="lp_cover">
          <Container>
            <div className="lp_cover_brand">GEOCHIC</div>
            <h1 className="lp_cover_title">Celebrate Global<br />Style, Beauty &amp; Culture</h1>
            <div className="lp_cover_tag">Lightpaper</div>
            <div className="lp_cover_url">www.geochicglobal.com</div>
          </Container>
        </section>

        <div className="lp_paper">
          <Container>
            <nav className="lp_toc" aria-label="Table of contents">
              <h2>Table of Contents</h2>
              <ol>
                {TOC_ITEMS.map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`}>{item.label}</a>
                  </li>
                ))}
              </ol>
            </nav>

            <section className="lp_section" id="abstract">
              <div className="lp_section_head">
                <span className="lp_num">01</span>
                <h2>Abstract</h2>
              </div>
              <div className="lp_text">
                <p>
                  Introducing GEOCHIC, a Web3 platform that funds outstanding creative
                  projects that celebrate global style, beauty, and culture. Driven by a
                  proprietary capital pool governed by creators, fans, and supporters,
                  GEOCHIC serves as a lead investor for small-to-medium scale artistic
                  ventures through compliant, fractional ownership. This approach enables
                  the community to directly back independent films, documentaries,
                  magazines, and other formats, thereby challenging the monopoly of large
                  media conglomerates and empowering creators worldwide.
                </p>
                <p>
                  Through this practical framework, GEOCHIC introduces a scalable model
                  for the Media and Entertainment industry. The platform brings together
                  creators with like-minded individuals, allowing them to finance, scale,
                  and collaborate on projects they are passionate about.
                </p>
                <p>
                  Built on the principle that vision, style, and creativity transcend
                  geographic and demographic boundaries, GEOCHIC establishes a truly
                  inclusive global marketplace for independent media.
                </p>
              </div>
            </section>

            <section className="lp_section" id="industry">
              <div className="lp_section_head">
                <span className="lp_num">02</span>
                <h2>Media &amp; Entertainment Industry</h2>
              </div>
              <div className="lp_text">
                <p>
                  The Media &amp; Entertainment Industry is a massive market encompassing
                  film, television, publishing, music, video games, theater, and art.
                  Yet, securing capital for small and medium-scale projects remains a
                  major obstacle. Regardless of their talent or concept quality,
                  independent artists find traditional funding practically impossible to
                  secure. Historically, media financing comes exclusively from legacy
                  film studios, television broadcasters, publishing companies, streaming
                  platforms, or institutional investors. Because most creators lack
                  industry connections or celebrity ambassadors, traditional funding
                  sources and loans routinely shut them out.
                </p>
                <p>
                  Furthermore, legacy media consolidation relies on outdated distribution
                  systems, middlemen, and financing models that heavily favor
                  large-scale, high-profile, celebrity-backed ventures. Independent
                  creators must instead self-fund or rely on friends and family.
                </p>
                <p>
                  Additionally, creative funding has devolved into a popularity contest.
                  Traditional platforms favor creators with massive social media
                  followings, leaving incredible talent behind simply because they lack
                  a digital audience. We believe a project&rsquo;s merit and cultural
                  value should never be reduced to a follower count. GEOCHIC aims to
                  shift the power back to the content itself. Here, your peers determine
                  the validity of your business model and the impact of your story,
                  ensuring great ideas win over big algorithms.
                </p>
                <p>
                  Fortunately, the creative industry is undergoing a massive disruption.
                  Tokenized Fractional Equity can transform content creation, financing,
                  distribution, and monetization. Fans can finally invest in creators who
                  inspire them intellectually, aesthetically, or culturally, directly
                  sharing in both their artistic journey and potential financial rewards.
                </p>
                <p>
                  The increasing global adoption of asset tokenization presents a unique
                  opportunity to propel media and entertainment into the future. By
                  developing the first compliance-first, fractional platform created
                  specifically to fund small-to-medium scale, high-quality projects that
                  celebrate creativity and vision, GEOCHIC is working to ensure that
                  talented creators around the world are no longer left behind.
                </p>
              </div>
            </section>

            <section className="lp_section" id="chic-collaborator">
              <div className="lp_section_head">
                <span className="lp_num">03</span>
                <h2>GEOCHIC&rsquo;s Chic Collaborator Concept</h2>
              </div>
              <div className="lp_text">
                <p>
                  GEOCHIC is designed to elevate the traditional venture capital model to
                  Web3, leveraging blockchain technology to act as a lead investor for
                  innovative film, television, magazine, and art projects. It offers a
                  long-overdue investment platform for emerging talent who lack the
                  corporate relationships to secure major capital but have powerful
                  stories to tell in uniquely personal ways. GEOCHIC will pool
                  decentralized capital specifically to back projects approved by our
                  community.
                </p>
                <p>
                  When the community votes to approve a proposal, GEOCHIC is structured
                  to automatically step in as the lead investor, providing 5% to 50% of
                  the requested amount through our capital allocation pool, with an
                  initial cap of $250,000 per project. Community approval signals
                  collective belief in the concept and a shared desire for its success.
                  This initial capital commitment jumpstarts the investment process, and
                  the community can then contribute the remaining capital via Fractional
                  Ownership. The creator receives the investment minus initial platform
                  fees, which are immediately reinvested to replenish the GEOCHIC
                  allocation pool for future creators.
                </p>
                <p>
                  By enabling creators to secure capital directly from supporters and
                  peers, GEOCHIC seeks to democratize the creative industry. We are
                  building an environment that offers creators unprecedented access to
                  resources, potential investors, and strategic partnerships while
                  unlocking exclusive benefits and ownership rights via Fractional
                  Ownership. This is designed to make creators, supporters, and investors
                  equally vested in the project&rsquo;s ultimate success.
                </p>
                <p>
                  This democratic process is built to shift power from studios,
                  streaming networks, and publishing conglomerates back to the fans and
                  creators. Together, they can produce personalized content that
                  reflects what audiences actually want to see, rather than what
                  maximizes corporate profit. There is an insatiable global demand for
                  authentic, culturally diverse content that accurately reflects our
                  world. This is especially true for young audiences who value inclusion
                  and representation as much as creative vision. GEOCHIC is committed to
                  supporting outstanding, innovative indie films, documentaries, and
                  episodic series that amplify diverse voices and feature inclusive
                  on-screen representation.
                </p>
                <p>
                  Similarly, independent publishing is experiencing a powerful
                  renaissance. The resurgence of indie magazines proves the enduring,
                  tactile power of print. However, these independent titles must rely on
                  copy sales and high cover prices because their print runs are too small
                  to attract traditional media agencies and advertisers. GEOCHIC intends
                  to accelerate this publishing renaissance. By using Fractional
                  Ownership, we aim to finance indie magazines with passionate, committed
                  readerships without requiring massive circulation numbers.
                </p>
                <p className="lp_quote">
                  Fractional Ownership has already transformed art, finance, and gaming.
                  Now, GEOCHIC brings that same revolutionary transformation to film,
                  television, and magazine production.
                </p>
              </div>
            </section>

            <section className="lp_section" id="funding-model">
              <div className="lp_section_head">
                <span className="lp_num">04</span>
                <h2>GEOCHIC Funding Model</h2>
              </div>
              <div className="lp_text">
                <p>
                  GEOCHIC aims to operate a frictionless, low-overhead funding model
                  designed to remove financial barriers for independent talent while
                  maintaining compliance with global digital asset frameworks. The
                  proposed workflow is structured as follows:
                </p>
              </div>
              <ul className="lp_flow_list lp_flow_list--boxed">
                {FUNDING_STEPS.map((step, i) => (
                  <li key={i}>
                    <strong>{step.label}:</strong> {step.text}
                  </li>
                ))}
              </ul>
            </section>

            <section className="lp_section" id="web3">
              <div className="lp_section_head">
                <span className="lp_num">05</span>
                <h2>Why Web3?</h2>
              </div>
              <div className="lp_text">
                <p>
                  Traditional equity crowdfunding is heavily hindered by geographic
                  borders, slow bank clearance times, and illiquid investment structures
                  that lock up fan capital for years. GEOCHIC seeks to leverage Web3
                  infrastructure to solve these exact systemic issues:
                </p>
              </div>
              <ul className="lp_flow_list">
                {WEB3_REASONS.map((reason, i) => (
                  <li key={i}>
                    <strong>{reason.label}:</strong> {reason.text}
                  </li>
                ))}
              </ul>
            </section>

            <section className="lp_section" id="co-ownership-passes">
              <div className="lp_section_head">
                <span className="lp_num">06</span>
                <h2>Fractional Ownership</h2>
              </div>
              <div className="lp_text">
                <p>
                  A Fractional Ownership token is designed to represent immutable digital
                  asset rights in a specific creative project and serve as a secure
                  validation of authenticity on the blockchain. By leveraging Tokenized
                  Fractional Ownership, GEOCHIC aims to enable creators to transform
                  their concepts into unique, asset-backed digital properties. This
                  structure seeks to safeguard intellectual property from unauthorized
                  duplication while facilitating decentralized ecosystem funding. When an
                  individual acquires a Fractional Ownership token, they gain exclusive
                  utility, governance rights, and potential reward rights associated
                  with that specific content. Beyond serving as a utility token, holding
                  these project tokens grants buyers special privileges, including
                  active participation in the project&rsquo;s journey, influence over
                  its creative direction, VIP launch access, and formal producer
                  credits.
                </p>
                <p>
                  GEOCHIC Fractional Ownership tokens aim to empower fans by establishing
                  a deep personal and emotional connection to the media they consume.
                  Instead of acting as passive subscribers to a traditional streaming
                  platform without a community stake, fans can experience the pride of
                  becoming verified patrons of a film or publication. Project token
                  holders can earn opportunities to appear in a travel series set in
                  their favorite city, spend time with production crews in exotic
                  locations, or contribute directly as collaborative editors,
                  photographers, or writers to a magazine that fuels their passion.
                  GEOCHIC Fractional Ownership tokens are built to foster an authentic
                  sense of belonging and active involvement, elevating the traditional
                  consumer experience to a collaborative partnership.
                </p>
              </div>
            </section>

            <section className="lp_section" id="utility-token">
              <div className="lp_section_head">
                <span className="lp_num">07</span>
                <h2>GEOCHIC Utility Token</h2>
              </div>
              <div className="lp_text">
                <p>
                  Ecosystem tokens play a vital role in the evolution of Web3 by
                  granting users the ability to engage in various utility and governance
                  actions within a decentralized network. GEOCHIC features its own
                  native utility token deployed on the institutional ERC-20 standard.
                  This standard provides a secure, universally accepted technical
                  framework for digital assets on the Ethereum blockchain, ensuring
                  seamless compatibility across Web3 wallets and platforms.
                </p>
                <p>
                  The minted GEOCHIC native token serves as the core economic engine of
                  the platform, offering users four primary utilities:
                </p>
              </div>
              <ul className="lp_flow_list">
                {UTILITY_BENEFITS.map((benefit, i) => (
                  <li key={i}>
                    <strong>{benefit.label}:</strong> {benefit.text}
                  </li>
                ))}
              </ul>
            </section>

            <section className="lp_section" id="tokenomics">
              <div className="lp_section_head">
                <span className="lp_num">08</span>
                <h2>Tokenomics</h2>
              </div>
              <div className="lp_text">
                <p>
                  Total supply: 100% (10,000,000 tokens). Initial supply: 20%. After completion
                  of the Private Sale and Presale, all the remaining tokens will be minted.
                </p>
              </div>
              <figure className="lp_figure">
                <div className="lp_tokenomics">
                  <div className="lp_donut" style={{ background: donutGradient() }}>
                    <div className="lp_donut_hole">
                      <span>10M</span>
                      <small>Total Supply</small>
                    </div>
                  </div>
                  <div className="lp_token_table_wrap">
                    <table className="lp_table">
                      <thead>
                        <tr>
                          <th>Allocation</th>
                          <th>% of Supply</th>
                          <th>Token Amount</th>
                          <th>Token Value (approx.)</th>
                          <th>Token Lock Duration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {TOKENOMICS.map((t) => (
                          <tr key={t.label}>
                            <td>
                              <span className="lp_dot" style={{ background: t.color }}></span>
                              {t.label}
                            </td>
                            <td>{t.pct}%</td>
                            <td>{t.amount}</td>
                            <td>{t.value}</td>
                            <td>{t.lock}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </figure>
            </section>

            <section className="lp_section" id="dao">
              <div className="lp_section_head">
                <span className="lp_num">09</span>
                <h2>Decentralized Autonomous Organization (DAO)</h2>
              </div>
              <div className="lp_text">
                <p>
                  GEOCHIC aims to operate as a decentralized community, shifting
                  governance away from centralized institutional gatekeepers and placing
                  it directly into the hands of global ecosystem participants. Users
                  enter the governance structure by acquiring and holding GEOCHIC native
                  tokens. The GEOCHIC DAO is designed to hold the authority over major
                  platform initiatives, including the final approval of projects
                  requesting matching capital from the GEOCHIC capital pool. This
                  structure connects like-minded creators and supporters around the
                  world, opening up opportunities for global collaboration while
                  ensuring absolute operational transparency.
                </p>
                <p>
                  In traditional media organizations, a rigid corporate hierarchy
                  dictates all operations. A formal board of directors, executives, or
                  upper management retains total control over funding, creative
                  direction, and structural changes. GEOCHIC seeks to dismantle this
                  outdated model. The governance rules, voting protocols, and treasury
                  mechanisms of the GEOCHIC DAO are engineered to be coded directly into
                  smart contracts on the blockchain. These rules are structured so they
                  cannot be altered, bypassed, or manipulated unless the global
                  community explicitly votes to change them, ensuring a fair,
                  transparent, and democratic creative marketplace.
                </p>
              </div>
            </section>

            <section className="lp_section" id="governance">
              <div className="lp_section_head">
                <span className="lp_num">10</span>
                <h2>Governance</h2>
              </div>
              <div className="lp_text">
                <p>
                  GEOCHIC&rsquo;s DAO intends to utilize the power of Quadratic Voting as
                  its core governance mechanism to determine collective community
                  decisions. This advanced structure is designed to solve the inherent
                  flaws of traditional &ldquo;one person, one vote&rdquo; models, where
                  individuals with intense preferences on a critical creative project
                  carry the exact same voting weight as those with weak preferences or
                  zero interest.
                </p>
                <p>
                  In our quadratic voting framework, participants use their held GEOCHIC
                  native tokens as voting credits to distribute across various creative
                  proposals. The defining feature of quadratic voting is that the cost
                  of casting multiple votes for a single proposal increases
                  quadratically relative to the number of votes desired. The
                  mathematical formula dictates that the cost of votes is equal to the
                  number of votes multiplied by themselves (Cost = Votes x Votes).
                </p>
                <p>
                  For example, if a participant allocates 10 tokens to the platform&rsquo;s
                  governance module, they can strategically distribute their power:
                </p>
              </div>
              <ul className="lp_flow_list">
                {VOTE_EXAMPLES.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
              <div className="lp_text">
                <p>
                  This quadratic cost curve ensures that additional votes become
                  increasingly expensive. This math radically mitigates plutocracy,
                  preventing a few wealthy token holders from dominating the
                  marketplace, while empowering everyday fans to collectively outvote
                  centralized entities.
                </p>
                <p>
                  The quadratic voting mechanism allows participants to express the true
                  intensity of their preferences by concentrating votes on the indie
                  films, documentaries, or magazines they care about the most. It
                  encourages community members to carefully calculate the value of each
                  additional vote and distribute their collective voting power
                  strategically across the ecosystem.
                </p>
              </div>
              <figure className="lp_figure">
                <div className="lp_voting_chart">
                  <div className="lp_bars">
                    {VOTING_COSTS.map((cost, i) => (
                      <div className="lp_bar_col" key={i}>
                        <div className="lp_bar" style={{ height: `${(cost / 120) * 100}%` }}>
                          <span>{cost}</span>
                        </div>
                        <div className="lp_bar_label">{i + 1}</div>
                      </div>
                    ))}
                  </div>
                  <div className="lp_chart_axis">Number of Votes &nbsp;&middot;&nbsp; Cost (Tokens)</div>
                </div>
              </figure>
              <div className="lp_text">
                <p>
                  Once the voting window closes, the DAO is built to automatically tally
                  the votes via on-chain smart contracts. The projects that successfully
                  cross the community threshold are approved, designed to trigger
                  GEOCHIC&rsquo;s role as the Chic Collaborator to secure the matching
                  lead capital.
                </p>
                <p>
                  Quadratic voting offers immense structural advantages for GEOCHIC. It
                  incentivizes community members to reveal their true creative
                  preferences, fosters deep project engagement, protects minority
                  interests, and allows for a remarkably accurate, fine-grained curation
                  process driven by authentic human passion.
                </p>
              </div>
            </section>

            <section className="lp_section" id="roadmap">
              <div className="lp_section_head">
                <span className="lp_num">11</span>
                <h2>Roadmap</h2>
              </div>
              <div className="lp_roadmap">
                {ROADMAP.map((phase, i) => (
                  <div className="lp_phase" key={phase.phase}>
                    <h3>{i + 1}&nbsp; {phase.phase.toUpperCase()}</h3>
                    <ul>
                      {phase.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </section>

            <section className="lp_section" id="team">
              <div className="lp_section_head">
                <span className="lp_num">12</span>
                <h2>Team</h2>
              </div>
              <div className="lp_photo_grid">
                {TEAM_PHOTOS.map((photo, i) => (
                  <figure className="lp_photo_grid_item" key={i}>
                    <img src={photo.img} alt={photo.credit} />
                    <span className="lp_photo_dot lp_photo_dot--on_image" style={{ background: photo.dot }} aria-hidden="true" />
                  </figure>
                ))}
              </div>
              <ul className="lp_photo_credits">
                {TEAM_PHOTOS.map((photo, i) => (
                  <li key={i}>
                    <span className="lp_photo_dot" style={{ background: photo.dot }} aria-hidden="true" />
                    {photo.credit}
                  </li>
                ))}
              </ul>
              <div className="lp_team_list">
                {TEAM.map((member) => (
                  <div className="lp_team_entry" key={member.name}>
                    <h3>
                      {member.name} &ndash;<br />
                      <span className="lp_red">{member.role.toUpperCase()}</span>
                    </h3>
                    <p>{member.bio}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="lp_section lp_contact" id="contact">
              <div className="lp_section_head">
                <span className="lp_num">13</span>
                <h2>Contact</h2>
              </div>
              <div className="lp_text">
                <p>
                  Ralph Clermont &mdash; Founder, CEO
                  <br />
                  <a href="mailto:ralph@geochicglobal.com">ralph@geochicglobal.com</a>
                </p>
              </div>
            </section>
          </Container>
        </div>
      </main>
    </>
  );
};

export default LitepaperPage;
